import * as React from 'react';
import { IconButton } from '@mui/material';
import { UserContext } from '../context/userContext';
import BookmarkAddOutlinedIcon from '@mui/icons-material/BookmarkAddOutlined';
import BookmarkAddedIcon from '@mui/icons-material/BookmarkAdded';

interface Props {
  isBookmarked: boolean;
  onBookmark: (isBookmarked: boolean) => void;
}

export const BookmarkConversation: React.FC<Props> = ({
  isBookmarked,
  onBookmark,
}) => {
  const handleClick = () => {
    onBookmark(!isBookmarked);
  };

  const { loggedIn } = React.useContext(UserContext);

  return (
    <>
      {loggedIn && (
        <IconButton
          sx={{
            color: 'black',
            margin: 0,
          }}
          onClick={handleClick}
          size="small"
        >
          {isBookmarked ? <BookmarkAddedIcon /> : <BookmarkAddOutlinedIcon />}
        </IconButton>
      )}
    </>
  );
};
